export const Logo = () => (
  <img
    src="https://assets.creditas.com/microfrontends/prod/website-assets/logotipos/1.0.0/creditas/Logo_default.png"
    alt="Logo da Creditas"
  />
)
